export default __webpack_public_path__ + "static/media/tamanna-rumee-mIqyYpSNq3o-unsplash.30f3a09d.png";